import { ItemModel, PackType } from '../../models/ItemModel';

interface IsUnitSizeEditableParams {
    editable: boolean;
    isCustomer: boolean;
    item: ItemModel;
}

export const isUnitSizeEditable = ({ editable, isCustomer, item }: IsUnitSizeEditableParams) => {
    if (!editable) {
        return false;
    }

    if (!isCustomer) {
        return true;
    }

    return item.packType === PackType.PAIL;
};
